module.exports = __webpack_public_path__ + "95e1957bc48d95276ca3f1940925ea16.png";